<template>
  <div style="margin-bottom:1%;">
    <el-upload
      action="#"
      v-show="uploadFlag"
      list-type="picture-card"
      :on-remove="handleRemove"
      :before-upload="onBeforeUploadImage"
      :http-request="UploadImage"
      :on-change="fileChange"
      :file-list="fileList"
      :show-file-list="false"
      :auto-upload="false"
      accept="image/jpeg,image/png,image/jpg,image/gif,image/bmp"
      ref="upload"
    >
      <el-button
        class="el-upload--picture-card"
        list-type="picture-card"
        slot="trigger"
      >
        <img src="../../assets/backImg.svg" />
      </el-button>
    </el-upload>
    <div class="img_div" v-if="fileList.length > 0 && !uploadFlag">
      <div class="mask">
        <h3>
          <!-- 删除 -->
          <i
            class="el-icon-delete"
            @click="handleRemove(fileList[0], fileList)"
          ></i>
        </h3>
      </div>
      <img class="imgCSS" :src="dialogImageUrl" alt="" />
    </div>
    <!-- <img width="1334px" height="146px" v-show="uploadFlag" :src="dialogImageUrl" alt="" /> -->
  </div>
</template>
<script>
export default {
  props: {
    uploadImgStyle: {
      type: Number,
      default: 0
    },
    imgIndex: {
      type: Number
    }
  },
  data() {
    return {
      // 上传的文件
      fileList: [],
      // 显示flag
      uploadFlag: true,
      dialogImageUrl: ""
    };
  },
  methods: {
    onBeforeUploadImage(file) {
      const isIMAGE =
        file.type === "image/jpeg" ||
        "image/jpg" ||
        "image/png" ||
        "image/gif" ||
        "image/bmp";
      const isLt1M = file.size / 1024 / 1024 < 10;
      console.log(
        "🚀 ~ file: UploadImg.vue:102 ~ onBeforeUploadImage ~ isLt1M:",
        isLt1M
      );
      console.log(
        "🚀 ~ file: UploadImg.vue:102 ~ onBeforeUploadImage ~ file.size:",
        file.size
      );
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
      }
      if (!isLt1M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isIMAGE && isLt1M;
    },
    UploadImage(file) {
      console.log("🚀 ~ file: UploadImg.vue:106 ~ UploadImage ~ file:", file);
      if (file.file != null) {
        this.uploadFlag = false;
      }
      const url = "/api/common/noticeUploadFile"; // 这个地址是请求接口的一个映射
      const formData = new FormData(); // 和后端协商后用formData格式进行传参
      formData.append("addFiles", file.file);
      // 当前用户id
      formData.append("userId", localStorage.getItem("userId"));
      // 创建用户的ID
      formData.append("creatUser", localStorage.getItem("userId"));
      this.$http
        .post(url, formData)
        .then(res => {
          // console.log(res);
          if (res.data.code === 200) {
            console.log("上传图片成功");
            this.dialogImageUrl = res.data.data;
            this.$emit("getPhotoLink", this.dialogImageUrl);
          }
          // console.log("🚀 ~ file: imcoder-tinymce.vue:160 ~ imgUpload ~ res.data.data", res.data.data)
        })
        .catch(err => {
          console.log("图片上传失败");
          console.log(err);
        });
      // formData.append("file", param.file);
      // UploadImageApi(formData)
      //   .then(response => {
      //     console.log("上传图片成功");
      //     param.onSuccess(); // 上传成功的图片会显示绿色的对勾
      //     // 但是我们上传成功了图片， fileList 里面的值却没有改变，还好有on-change指令可以使用
      //   })
      //   .catch(response => {
      //     console.log("图片上传失败");
      //     param.onError();
      //   });
    },
    fileChange(file) {
      if (file != null && file.size / 1024 / 1024 < 10) {
        this.uploadFlag = false;
      }
      const isIMAGE =
        file.type === "image/jpeg" ||
        "image/jpg" ||
        "image/png" ||
        "image/gif" ||
        "image/bmp";
      const isLt1M = file.size / 1024 / 1024 < 10;
      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式!");
        return;
      }
      if (!isLt1M) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return;
      }
      // console.log("🚀 ~ file: UploadImg.vue:149 ~ fileChange ~ file:", file);
      this.dialogImageUrl = URL.createObjectURL(file.raw);
      console.log("11111111111");
      this.$emit("getImgInfo", {
        file: file,
        url: this.dialogImageUrl,
        index: this.imgIndex
      });
      this.$refs.upload.clearFiles(); //清除文件对象
      this.logo = file.raw; // 取出上传文件的对象，在其它地方也可以使用
      this.fileList = [{ name: file.name, url: file.url }]; // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象
      // console.log("🚀 ~ file: UploadImg.vue:158 ~ fileChange ~ this.fileList:", this.fileList)
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.dialogImageUrl = "";
      this.$emit("deleteFile", this.imgIndex);
      this.uploadFlag = true;
    },
    setImgUrl(obj) {
      this.dialogImageUrl = obj.inputTitleLink;
      this.uploadFlag = obj.uploadFlag;
      this.fileList = [{ ...obj.linkImgInfo.file }];
    }
  }
};
</script>
<style scoped lang="scss">
.img_div {
  // border-radius: 10px;
  display: block;
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 208px;
}

.imgCSS {
  max-width: 100%;
  height: 208px;
  width: 100%;
  // border-radius: 10px;
  display: block;
  cursor: pointer;
}

.mask {
  position: absolute;
  background: rgba(101, 101, 101, 0.6);
  color: #ffffff;
  opacity: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  // border-radius: 10px;
  pointer-events: none;
}
/** 上传按钮的框框1 */
>>> .el-upload--picture-card {
  width: 100%;
  height: 208px;
  border: 1px dashed #d7d7d7;
  // background-image: "@/assets/backImg.svg";
}

.mask h3 {
  text-align: center;
  pointer-events: auto;
}
.img_div:hover .mask {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Common/AutoUploadImg.vue